import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view09ImageOptions } from './views/exterior_view09'

class X49MK2Sprayhood extends Component {
    constructor(props) {
        super(props);
        this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
    }


    handleSprayhoodChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Sprayhood = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view09ImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Sprayhood' /></h1>

                    <p><Trans defaults='X49 Sprayhood Text 1' /></p>
                    <p><Trans defaults='X49 Sprayhood Text 2' /></p>
                    <MaterialSelector label={this.props.configuration.Sprayhood.label} options={this.props.sprayhoodOptions} value={this.props.configuration.Sprayhood} onChange={this.handleSprayhoodChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2Sprayhood);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-Sprayhood.js